import api from './api';
import { mapOvertimeApprovalDto } from '../dto/OvertimeApprovalDTO';

export const getOvertimeApprovals = async ({ role, userId }) => {
    if (role === 'admin' || role === 'super_admin') {
        const res = await api.get('/OvertimeApproval');
        return (res.data || []).map(mapOvertimeApprovalDto);
    }
    const res = await api.get(`/OvertimeApproval/user/${userId}`);
    return (res.data || []).map(mapOvertimeApprovalDto);
};

export const approveOvertimeApproval = async (id) => {
    const res = await api.post(`/OvertimeApproval/${id}/approve`);
    return res.data;
};

export const rejectOvertimeApproval = async (id, reason = null) => {
    const res = await api.post(`/OvertimeApproval/${id}/reject`, { reason });
    return res.data;
};

export const getPendingOvertimeCount = async () => {
    const res = await api.get('/OvertimeApproval/pending-count');
    return res.data?.count ?? 0;
};

/** The open requests, oldest first. Not `getOvertimeApprovals` filtered by status: that returns
 *  every status newest-first under a row cap, so the oldest unanswered one falls off the end. */
export const getPendingOvertimeApprovals = async (limit) => {
    const res = await api.get('/OvertimeApproval/pending', {
        params: limit ? { limit } : undefined,
    });
    return {
        items: (res.data?.items || []).map(mapOvertimeApprovalDto),
        total: res.data?.total ?? 0,
    };
};
